import { IconButton } from "../../../components";
import { TrashOutline } from "../../../assets";
import { useLanguage } from "../../../hooks";
import CategoryInput from "./CategoryInput";

// Una fila del editor: el EAN, su categoría y, si se conoce, el producto (solo
// lectura, para identificar el EAN).
export interface EanLinkRow {
  ean: string;
  category: string;
  productName?: string | null;
}

interface EanLinksEditorProps {
  rows: EanLinkRow[];
  onChange: (rows: EanLinkRow[]) => void;
}

// EANs de una marca con su categoría, añadiendo y quitando filas dinámicamente
// (sustituye al antiguo campo de texto "EAN1, EAN2, ...").
const EanLinksEditor: React.FC<EanLinksEditorProps> = ({ rows, onChange }) => {
  const { t } = useLanguage();
  const s = t.adminUsersScreen.eanLinks;

  // Predictivo: categorías ya usadas en esta marca.
  const categories = Array.from(
    new Set(rows.map((row) => row.category.trim()).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b, "es"));

  const update = (index: number, change: Partial<EanLinkRow>) =>
    onChange(rows.map((row, i) => (i === index ? { ...row, ...change } : row)));

  return (
    <div className="ean-links">
      {rows.length > 0 && (
        <div className="ean-links-row ean-links-head">
          <span>{s.ean}</span>
          <span>{s.category}</span>
          <span>{s.product}</span>
          <span />
        </div>
      )}

      {rows.map((row, index) => (
        <div className="ean-links-row" key={`ean-link-${index}`}>
          <input
            className="edit-box ean-links-ean"
            value={row.ean}
            placeholder={s.eanPlaceholder}
            onChange={(e) => update(index, { ean: e.target.value.trim() })}
          />
          <CategoryInput
            value={row.category}
            categories={categories}
            placeholder={s.categoryPlaceholder}
            onChange={(category) => update(index, { category })}
          />
          <span
            className="ean-links-product"
            title={row.productName ?? undefined}
          >
            {row.productName ?? (row.ean ? s.productUnknown : "")}
          </span>
          <IconButton
            icon={TrashOutline}
            alt={s.remove}
            variant="danger"
            onClick={() => onChange(rows.filter((_, i) => i !== index))}
          />
        </div>
      ))}

      <button
        type="button"
        className="ean-links-add"
        onClick={() => onChange([...rows, { ean: "", category: "" }])}
      >
        + {s.add}
      </button>
    </div>
  );
};

export default EanLinksEditor;
